import { LightningElement,api } from "lwc";
import type { MarketingCardSummary } from "./types";
export type { MarketingCardSummary };

export default class MarketingCard extends LightningElement {
    static renderMode = "light";
    @api cardsummary: MarketingCardSummary = null!;
}
